// extracted by mini-css-extract-plugin
export default {"outer":"pills_outer__VsUTS","inner":"pills_inner__5fni1","pill":"pills_pill__2LAbB","button":"pills_button__NCevw"};